<template>
  <section
    class="rounded-lg border px-4 py-3 text-left"
    :class="errors.length ? 'border-negative bg-red-50' : 'border-primary10 bg-[#F3F9FB]'"
    aria-live="polite"
    data-testid="qualification-policy-summary"
  >
    <div class="flex flex-wrap items-center justify-between gap-2">
      <h4 class="text-xs font-bold uppercase tracking-wider text-primary40">
        O que esta escala exige
      </h4>
      <div v-if="!errors.length" class="flex flex-wrap gap-2">
        <LabelBadge
          v-if="count.BLOCK"
          :label="`${count.BLOCK} ${count.BLOCK === 1 ? 'bloqueia' : 'bloqueiam'}`"
          color="red"
          size="small"
          :icon="mdiLockOutline"
        />
        <LabelBadge
          v-if="count.PRE_ALLOCATE"
          :label="`${count.PRE_ALLOCATE} ${count.PRE_ALLOCATE === 1 ? 'permite' : 'permitem'} pré-alocação`"
          color="orange"
          size="small"
          :icon="mdiClockOutline"
        />
      </div>
    </div>
    <p
      class="mt-1.5 text-sm leading-6 text-textPrimary"
      data-testid="qualification-policy-summary-text"
    >
      {{ text }}
    </p>
    <ul
      v-if="errors.length"
      class="mt-2 flex flex-col gap-1"
      data-testid="qualification-policy-summary-errors"
    >
      <li v-for="error in errors" :key="error" class="text-sm text-negative">{{ error }}</li>
    </ul>
    <p v-else-if="count.PRE_ALLOCATE" class="mt-1.5 text-xs text-gray-600">
      Pré-alocação só acontece quando <strong>todos</strong> os critérios que o médico não atende
      permitem pré-alocação. Cada pré-alocação abre uma demanda urgente para o Time de Documentação.
    </p>
    <p v-else-if="count.BLOCK" class="mt-1.5 text-xs text-gray-600">
      Quem não atender será recusado na alocação com a lista do que falta (sem liberação manual).
    </p>
  </section>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { mdiClockOutline, mdiLockOutline } from '@mdi/js'

import LabelBadge from '@/components/designSystem/Badges/LabelBadge.vue'
import { useProfessionalDocumentCatalogStore } from '@/pinia-store/useProfessionalDocumentCatalogStore'
import type { QualificationRuleGroup } from '@/types/qualification-policy.types'

import { countByOnFail, summarizePolicy } from './policyModel'

const props = withDefaults(defineProps<{ policy: QualificationRuleGroup; errors?: string[] }>(), {
  errors: () => []
})

// Só lê o catálogo (nomes por chave); quem carrega é a seção. Sem nome, sai a chave.
const catalog = useProfessionalDocumentCatalogStore()
const text = computed(() => summarizePolicy(props.policy, catalog.reasonName))
const count = computed(() => countByOnFail(props.policy))
</script>
